"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME_PREFERENCES = void 0;
/** My Profile > Appearance (Prisma enum `ThemePreference`). LIGHT by default; SYSTEM follows the OS. */
exports.THEME_PREFERENCES = ['LIGHT', 'DARK', 'SYSTEM'];
//# sourceMappingURL=user.js.map